import { apiSlice } from "./apiSlice";
export const procurementDpItemsSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllProcurementDpItems: builder.query({
            query: (params) => ({
                url: `ProcurementDpItem`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllProcurementDpItemsTracker"],
        }),
        getProcurementDpItemsDetail: builder.query({
            query: (req) => ({
                url: `ProcurementDpItem/${req}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        addProcurementDpItems: builder.mutation({
            query: (body) => ({
                url: `ProcurementDpItem`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['AllProcurementDpItemsTracker']
        }),

        editProcurementDpItems: builder.mutation({
            query: (body) => ({
                url: `ProcurementDpItem`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['AllProcurementDpItemsTracker']
        }),
        deleteProcurementDpItems: builder.mutation({
            query: (procurementDPItemId) => ({
                url: `ProcurementDpItem/${procurementDPItemId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['AllProcurementDpItemsTracker']
        }),
        getExportAllProcurementDpItem: builder.query({
            query: (params) => ({
                url: `ProcurementDpItem`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

    }),
});

export const {
    useLazyGetAllProcurementDpItemsQuery,
    useEditProcurementDpItemsMutation,
    useAddProcurementDpItemsMutation,
    useGetAllProcurementDpItemsQuery,
    useGetProcurementDpItemsDetailQuery,
    useDeleteProcurementDpItemsMutation,
    useLazyGetExportAllProcurementDpItemQuery
} = procurementDpItemsSlice;
